import { render, staticRenderFns } from "./ShareSettings.vue?vue&type=template&id=27953857&scoped=true"
import script from "./ShareSettings.vue?vue&type=script&lang=js"
export * from "./ShareSettings.vue?vue&type=script&lang=js"
import style0 from "./ShareSettings.vue?vue&type=style&index=0&id=27953857&prod&scoped=true&lang=scss"
import style1 from "./ShareSettings.vue?vue&type=style&index=1&id=27953857&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27953857",
  null
  
)

export default component.exports